import { ATTACHMENT_PREVIEW } from "../../../features/supportTickets/supportTicketsSlice";

// Shared labels/mapping for the support-ticket dashboard. Statuses and
// categories mirror the backend ticket.model enums.

// tone: the status pill's color. Open and pending wait on support, waiting
// on the player; resolved is closed.
export const STATUS_META = {
  open: { label: "مفتوحة", tone: "danger" },
  pending: { label: "قيد المعالجة", tone: "warning" },
  waiting: { label: "بانتظار الرد", tone: "info" },
  resolved: { label: "تم الحل", tone: "success" },
};

export const STATUS_FILTERS = [
  { value: "", label: "الكل" },
  { value: "open", label: "مفتوحة" },
  { value: "pending", label: "قيد المعالجة" },
  { value: "waiting", label: "بانتظار الرد" },
  { value: "resolved", label: "تم الحل" },
];

export const CATEGORY_LABELS = {
  payments: "المدفوعات",
  tournaments: "البطولات",
  account: "الحساب",
  technical: "مشكلة تقنية",
  squad: "السكواد والأصدقاء",
  bug: "خطأ برمجي",
  feature: "اقتراح ميزة",
};

export const CATEGORY_OPTIONS = [
  { value: "", label: "كل التصنيفات" },
  ...Object.entries(CATEGORY_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

// The owner's CSAT stars (backend rating filter: "1"…"5", "rated", "unrated").
export const RATING_OPTIONS = [
  { value: "", label: "كل التقييمات" },
  { value: "rated", label: "المُقيَّمة فقط" },
  { value: "5", label: "★★★★★ (5)" },
  { value: "4", label: "★★★★ (4)" },
  { value: "3", label: "★★★ (3)" },
  { value: "2", label: "★★ (2)" },
  { value: "1", label: "★ (1)" },
  { value: "unrated", label: "بدون تقييم" },
];

export const statusLabel = (status) => STATUS_META[status]?.label || status;
export const categoryLabel = (category) =>
  CATEGORY_LABELS[category] || category;

// Arabic count agreement: 1, 2, 3–10, 11+.
export const ticketCountLabel = (count) => {
  if (count === 1) return "تذكرة واحدة";
  if (count === 2) return "تذكرتان";
  if (count >= 3 && count <= 10) return `${count} تذاكر`;
  return `${count.toLocaleString("en")} تذكرة`;
};

// A list preview: the backend's image-only placeholder, in Arabic.
export const previewText = (lastMessage) =>
  lastMessage === ATTACHMENT_PREVIEW ? "📎 صورة" : lastMessage || "";
